module.exports = __webpack_public_path__ + "img/filters-page-1.ff5861b7.png";